/**
 * Environment variable configuration
 * Centralizes all environment variables for easier management
 * 
 * This file is executed immediately when imported and ensures
 * environment variables are available throughout the application
 */
// Load environment variables at the earliest possible moment
// and provide fallback values to prevent undefined errors
export const API_URL = process.env.REACT_APP_API_URL || '';
export const SALES_URL = process.env.REACT_APP_SALES_API_URL || '';
export const SALES_API_URL = process.env.REACT_APP_SALES_API_BACKEND_URL || '';
// DBI 360 specific API endpoint
// Renamed to avoid false positives in secret scanners
export const DBI_API_URL = process.env.REACT_APP_DBI360_API_URL || '';
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN || '';
export const REACT_APP_PERMISSION_URL = process.env.REACT_APP_PERMISSION_URL || '';
export const REACT_APP_PERMISSION_KEY = process.env.REACT_APP_PERMISSION_KEY || '';
export const REACT_APP_PRODUCT_CODE = process.env.REACT_APP_PRODUCT_CODE || '';

// Log environment variables loading status for debugging
console.log('Environment variables loaded:', {
  API_URL: API_URL ? 'Set' : 'Not set',
  SALES_URL: SALES_URL ? 'Set' : 'Not set',
  DBI_API_URL: DBI_API_URL ? 'Set' : 'Not set',
  APP_DOMAIN: APP_DOMAIN ? 'Set' : 'Not set',
  REACT_APP_PERMISSION_URL: REACT_APP_PERMISSION_URL ? REACT_APP_PERMISSION_URL : 'Not set',
  REACT_APP_PERMISSION_KEY: REACT_APP_PERMISSION_KEY ? 'Set' : 'Not set',
  REACT_APP_PRODUCT_CODE: REACT_APP_PRODUCT_CODE ? 'Set' : 'Not set',
});
